import GasView from "./view";

const Gas = () => {
  return <GasView />;
};

export default Gas;
